import * as core from '../../../../../../../core'
import * as changeImpactAnticipatedResponse from '../change-impact-anticipated-response'

export const RESOURCE = {
  payload: {
    description: 'Mixed',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactAnticipatedResponse.RESOURCE.payload.partialId,
    }),
    id: 'Mixed',
    name: 'Mixed',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
